import { render, staticRenderFns } from "./ControversyAgreement.vue?vue&type=template&id=d88b4eb6&scoped=true"
import script from "./ControversyAgreement.vue?vue&type=script&lang=js"
export * from "./ControversyAgreement.vue?vue&type=script&lang=js"
import style0 from "./ControversyAgreement.vue?vue&type=style&index=0&id=d88b4eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88b4eb6",
  null
  
)

export default component.exports